import styled from 'styled-components';

export const HeaderStyled = styled.header`
  padding-top: 16px;

  @media (min-width: 768px) {
    padding-top: 24px;
  }

  @media (min-width: 1280px) {
    padding-top: 20px;
  }
`;
